// 跳转供方地址
// const path = 'http://sdssupply.caishen.cn/index.html#/' // 测试
const path = 'https://supplier.sds18.com/index.html#/'
// const path = 'https://old.sds18.com/supplier/index.html#/'

export default path
